module.exports = "https://static.wmbcdn.com/uniweb/images/58459a951c2c86379556c86b552f30a8.svg";